// extracted by mini-css-extract-plugin
export default {"iframe":"p9h3PJ","fillAllSpace":"SmtVJN","absolute":"gjzZnu"};